import {
    CREATE_USER,
    CREATE_USER_SUCCESS,
    GET_ALL_USERS,
    SET_ALL_USERS,
    GET_USER_BY_ID,
    SET_USER_BY_ID,
    GET_MODULES_LIST,
    SET_MODULES_LIST,
    GET_USER_MODULES,
    SET_USER_MODULES,
    DOWNLOAD_PREVIOUS_YEAR_RESULTS,
    SET_DOWNLOAD_PREVIOUS_YEAR_RESULTS_DATA,
    EXPORT_USERS_ASSESSMENTS,
    SET_USERS_ASSESSMENTS_EXCEL_DATA,
    GET_USER_ATTEMPTS_BY_ID,
    SET_USER_ATTEMPTS_BY_ID,
    GET_USERS_COST_CENTERS_FILTER_LIST,
    SET_USERS_COST_CENTERS_FILTER_LIST,
    GET_USERS_HOME_COST_CENTERS_FILTER_LIST,
    SET_USERS_HOME_COST_CENTERS_FILTER_LIST,
    GET_USERS_LATEST_SCORE_FILTER_LIST,
    SET_USERS_LATEST_SCORE_FILTER_LIST,
    GET_USERS_BY_COST_CENTER,
    SET_USERS_BY_COST_CENTER,
    GET_SAVE_USER_BY_COST_CENTER,
    SET_SAVE_USER_BY_COST_CENTER,
    GET_USER_COST_CENTERS,
    SET_USER_COST_CENTERS,
    GET_USER_COST_CENTERS_MODULES_LIST,
    SET_USER_COST_CENTERS_MODULES_LIST,
    GET_SAVE_USER_COST_CENTERS_MODULES,
    SET_SAVE_USER_COST_CENTERS_MODULES
} from './UsersTypes'

const createUser = (user: any) => ({
    type: CREATE_USER,
    user
});

const setUserCreationSuccess = (flag: any) => ({
    type: CREATE_USER_SUCCESS,
    flag
})

const getAllUsers = (payload: any) => {
    return {
        type: GET_ALL_USERS,
        payload
    }
}

const setAllUsers = (usersList: any) => {
   return {
        type: SET_ALL_USERS,
        usersList
    }
}

const getUserById = (id: any, costCenter: string) => {
    return {
       type: GET_USER_BY_ID,
       id,
       costCenter
   }
}

const setUserById = (userById: any) => {
    return {
        type: SET_USER_BY_ID,
        userById
    }
}

const getModulesList = () => {
    return {
        type: GET_MODULES_LIST,
    }
}

const setModulesList = (modulesList: any) => {
    return {
         type: SET_MODULES_LIST,
         modulesList
     }
 }

 const getUserModules = (emailId: any) => {
    return {
       type: GET_USER_MODULES,
       emailId
   }
}

const setUserModules = (userModules: any) => {
    return {
         type: SET_USER_MODULES,
         userModules
     }
 }

 const downloadPreviousYearResult = () => {
    return {
        type: DOWNLOAD_PREVIOUS_YEAR_RESULTS,
    }
}

const setPreviousYearResultData = (response: any) => {
   return {
        type: SET_DOWNLOAD_PREVIOUS_YEAR_RESULTS_DATA,
        response
    }
}

const exportUsersAssessments = (payload: any) => {
    return {
        type: EXPORT_USERS_ASSESSMENTS,
        payload
    }
}

const setUsersAssessmentsExcelData = (response: any) => {
   return {
        type: SET_USERS_ASSESSMENTS_EXCEL_DATA,
        response
    }
}

const getUserAttemptsById = (payload: any) => {
    return {
        type: GET_USER_ATTEMPTS_BY_ID,
        payload
    }
}

const setUserAttemptsById = (response: any) => {
   return {
        type: SET_USER_ATTEMPTS_BY_ID,
        response
    }
}

const getUsersCostCenterFilterList = () => {
    return {
        type: GET_USERS_COST_CENTERS_FILTER_LIST
    }
}

const setUsersCostCenterFilterList = (response: any) => {
   return {
        type: SET_USERS_COST_CENTERS_FILTER_LIST,
        response
    }
}

const getUsersHomeCostCenterFilterList = () => {
    return {
        type: GET_USERS_HOME_COST_CENTERS_FILTER_LIST
    }
}

const setUsersHomeCostCenterFilterList = (response: any) => {
   return {
        type: SET_USERS_HOME_COST_CENTERS_FILTER_LIST,
        response
    }
}

const getUsersLatestScoreFilterList = () => {
    return {
        type: GET_USERS_LATEST_SCORE_FILTER_LIST
    }
}

const setUsersLatestScoreFilterList = (response: any) => {
   return {
        type: SET_USERS_LATEST_SCORE_FILTER_LIST,
        response
    }
}

const getUsersByCostCenter = (payload: any) => {
    return {
        type: GET_USERS_BY_COST_CENTER,
        payload
    }
}

const setUsersByCostCenter = (usersByCostCenter: any) => {
    return {
        type: SET_USERS_BY_COST_CENTER,
        usersByCostCenter
    }
}

const getSaveUserByCostCenter = (payload: any) => {
    return {
        type: GET_SAVE_USER_BY_COST_CENTER,
        payload
    }
}

const setSaveUserByCostCenter = (isSaveUserByCostCenter: any) => {
    return {
        type: SET_SAVE_USER_BY_COST_CENTER,
        isSaveUserByCostCenter : isSaveUserByCostCenter
    }
}

const getUserCostCentersDropDownList = (userId: any, loggedUserId: any) => {
    return {
        type: GET_USER_COST_CENTERS,
        userId,
        loggedUserId
    }
}

const setUserCostCentersDropDownList = (response: any) => {
    return {
        type: SET_USER_COST_CENTERS,
        response
    }
}

const getUserCostCentersModulesList = (payload:any) => {
    return {
        type: GET_USER_COST_CENTERS_MODULES_LIST,
        payload
    }
}

const setUserCostCenterModulesList = (response: any) => {
   return {
        type: SET_USER_COST_CENTERS_MODULES_LIST,
        response
    }
}

const getSaveUserCostCentersModules = (payload:any) => {
    return {
        type: GET_SAVE_USER_COST_CENTERS_MODULES,
        payload
    }
}

const setSaveUserCostCenterModules = (response: any) => {
   return {
        type: SET_SAVE_USER_COST_CENTERS_MODULES,
        response
    }
}

export {
    createUser,
    setUserCreationSuccess,
    getAllUsers,
    setAllUsers,
    getUserById,
    setUserById,
    getModulesList,
    setModulesList,
    getUserModules,
    setUserModules,
    downloadPreviousYearResult,
    setPreviousYearResultData,
    exportUsersAssessments,
    setUsersAssessmentsExcelData,
    getUserAttemptsById,
    setUserAttemptsById,
    getUsersCostCenterFilterList,
    setUsersCostCenterFilterList,
    getUsersHomeCostCenterFilterList,
    setUsersHomeCostCenterFilterList,
    getUsersLatestScoreFilterList,
    setUsersLatestScoreFilterList,

    getUsersByCostCenter,
    setUsersByCostCenter,
    getSaveUserByCostCenter,
    setSaveUserByCostCenter,
    getUserCostCentersDropDownList,
    setUserCostCentersDropDownList,
    getUserCostCentersModulesList,
    setUserCostCenterModulesList,
    getSaveUserCostCentersModules,
    setSaveUserCostCenterModules
}